export const SET_ANALYTICS = 'SET_ANALYTICS';
export const CLEAR_ANALYTICS = 'CLEAR_ANALYTICS';

export const clearAnalytics = {
  type: CLEAR_ANALYTICS,
}

export const setAnalytics = (data) => {
  return {
    type: SET_ANALYTICS,
    payload: data,
  }
}